module.exports = __webpack_public_path__ + "img/制御工学1_10.81d21dbe.png";